import React, { useState, useEffect, useRef } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const SecretCodeGame = () => {
  const [startNumber, setStartNumber] = useState(0);
  const [goal, setGoal] = useState(100);
  const [inputValue, setInputValue] = useState('');
  const [result, setResult] = useState('');
  const [lockStatus, setLockStatus] = useState('🧰');
  const [lockClass, setLockClass] = useState('');
  const successSoundRef = useRef(null);
  const failSoundRef = useRef(null);

  const style = {
    body: {
      fontFamily: "'Comic Sans MS', cursive",
      background: '#fffde7',
      textAlign: 'center',
      padding: '40px 10px',
      minHeight: '100vh',
      boxSizing: 'border-box',
    },
    title: {
      color: '#4e342e',
      fontSize: 'clamp(1.5rem, 5vw, 2.5rem)',
    },
    lock: {
      fontSize: 'clamp(3rem, 8vw, 5rem)',
      margin: '20px 0',
    },
    question: {
      fontSize: 'clamp(1rem, 3vw, 1.5rem)',
      margin: '20px 0',
    },
    input: {
      fontSize: '1.5rem',
      padding: '10px',
      width: '100px',
      borderRadius: '8px',
      border: '1px solid #ccc',
      marginRight: '10px',
      textAlign: 'center',
    },
    inputWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexWrap: 'wrap',
      marginBottom: '10px',
      gap: '10px',
    },
    button: {
      fontSize: '1rem',
      padding: '10px 15px',
      border: 'none',
      borderRadius: '8px',
      backgroundColor: '#6d4c41',
      color: 'white',
      cursor: 'pointer',
    },
    select: {
      fontSize: '1rem',
      padding: '10px 15px',
      margin: '10px',
      border: 'none',
      borderRadius: '8px',
      backgroundColor: '#ffe082',
    },
    result: {
      fontSize: '1.2rem',
      marginTop: '20px',
      height: '40px',
      fontWeight: 'bold',
    },
    unlocked: {
      color: 'green',
      animation: 'pop 0.5s ease',
    },
    locked: {
      color: 'red',
    },
  };

  useEffect(() => {
    newChallenge();
  }, []);

  const newChallenge = () => {
    const newGoal = parseInt(document.getElementById('level').value);
    const newStart = Math.floor(Math.random() * (newGoal - 10));
    setGoal(newGoal);
    setStartNumber(newStart);
    setInputValue('');
    setResult('');
    setLockStatus('🧰');
    setLockClass('');
  };

  const checkCode = () => {
    const input = parseInt(inputValue);
    const correct = goal - startNumber;
    if (input === correct) {
      setResult(`✅ Correct! ${startNumber} + ${input} = ${goal}`);
      setLockStatus('🔓');
      setLockClass('unlocked');
      successSoundRef.current?.play();
            const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setResult('❌ Try again!');
      setLockClass('locked');
      failSoundRef.current?.play();
    }
  };

  return (
    <div style={style.body}>
      <h1 style={style.title}>🔐 Secret Code: Unlock the Treasure!</h1>
      <div
        style={{
          ...style.lock,
          ...(lockClass === 'unlocked'
            ? style.unlocked
            : lockClass === 'locked'
            ? style.locked
            : {}),
        }}
      >
        {lockStatus}
      </div>

      <div style={style.question}>
        The code starts with <strong>{startNumber}</strong>. What’s the second part to reach{' '}
        <strong>{goal}</strong>?
      </div>
<label htmlFor="level">Level:</label>
      <select
        id="level"
        style={style.select}
        defaultValue="100"
        onChange={newChallenge}
      >
        <option value="100">Unlock 100</option>
        <option value="200">Unlock 200</option>
        <option value="500">Unlock 500</option>
      </select>
      <div style={style.inputWrapper}>
        <input
          type="number"
          style={style.input}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="?"
        />
        <button style={style.button} onClick={checkCode}>
          Unlock
        </button>
      </div>

      <div style={style.result}>{result}</div>

      <button
        style={{ ...style.button, backgroundColor: '#4e342e', marginTop: '10px' }}
        onClick={newChallenge}
      >
        Next
      </button>

      <br />
      <br />
      

      <audio
        ref={successSoundRef}
        src="https://cdn.pixabay.com/download/audio/2022/03/15/audio_e28f749370.mp3?filename=correct-2-46134.mp3"
      />
      <audio
        ref={failSoundRef}
        src="https://cdn.pixabay.com/download/audio/2022/03/15/audio_b0d8424c27.mp3?filename=error-2-36058.mp3"
      />
    </div>
  );
};

export default SecretCodeGame;
